const apiUrl = process.env.REACT_APP_API_URL;
export const GetProjecteIdInforme = async (id_projecte : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/informe`);
        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
